import MainButton from 'components/Button'

function Button({ isPrimary, onClick, children, href }) {
    let classList = ""
    if (isPrimary)
        classList = "btn-primary"
    else
        classList = "btn-ghost"

    return (
        <MainButton
            classList={classList}
            onClick={onClick}
            href={href}
        >
            {children}
        </MainButton>
    )
}

export default Button;